'use strict';

module.exports = {
  disable: {
    null: ['autolink', 'codeIndented', 'htmlFlow', 'htmlText']
  }
};